import { OpenFeature } from "@openfeature/web-sdk";
import {
  LoaderFunction,
  Outlet,
  redirect,
  useLoaderData,
} from "react-router-dom";

import { get } from "@/api";
import { Models } from "@/api/types";
import { Image } from "@/atoms";
import { queryClient } from "@/pages/Root";
import LoadingLayout from "@/pages/root/LoadingLayout";
import { waitObj } from "@/toolbox/Promise";
import { isNativePlatform } from "@/utils/platform.helpers";

export const PublicReferralRewardLayout = () => {
  const { platform } = useLoaderData() as {
    platform: Models<"PlatformModel">;
  };

  return (
    <>
      <LoadingLayout />

      <div className="PublicReferralRewardLayout mx-auto flex min-h-screen w-full max-w-[390px] flex-col">
        <Outlet />
      </div>
    </>
  );
};

export const PublicReferralRewardLayoutLoader: LoaderFunction = async ({
  request,
}: any) => {
  const platform = await queryClient.fetchQuery(["/platform/current"], () =>
    get("/platform/current").catch(() => null)
  );

  // Ensure we have a platform context for feature flagging targeting rules
  OpenFeature.setContext({
    platform: platform
      ? {
          targetingKey: platform.id,
        }
      : null,
  });

  // If the platform is not active, redirect to the deactivated page
  if (platform && !platform.active) {
    if (
      (isNativePlatform() && !request.url.includes("/signin")) ||
      !isNativePlatform()
    ) {
      return redirect("/deactivated");
    }

    return null;
  }

  return waitObj({
    platform,
  });
};
